import { useState } from "react";
import Cookies from "js-cookie";
import AuthenticationContext from "./AuthenticationContext";
import { useEffect } from "react";
// admin access level: [5, 7, 8, 9, 10, 11, 12]
// customer access level : [13,14,15,16]
interface UserInformation {
  token: string;
  fullName: string;
  userType: number;
  mobile: number;
  profilePicture: string | undefined;
  userName: string;
  accessLevel: number[];
  id: any;
}
export default function Authentication({ children }: { children: JSX.Element }) {
  const [userInfo, setUserInfo] = useState<UserInformation>({
    token: "",
    fullName: "",
    userType: -1,
    mobile: 0,
    profilePicture: "",
    userName: Cookies.get("userName") ? Cookies.get("userName") : "",
    accessLevel: Cookies.get("accessLevel") ? Cookies.get("accessLevel") : [],
    id: Cookies.get("id") ? Cookies.get("id") : null,
  });

  const [isLogged, setIsLogged] = useState<boolean>(Cookies.get("isLogged") ? true : false);

  useEffect(() => {
    checkCookie();
  }, []);

  function login(token: string, fullName: string, userType: number, mobile: number, profilePicture: string | undefined, userName: string, accessLevel: number[], id: any): void {
    if (token) {
      if (userType == 1) {
        accessLevel = [13, 14, 15, 16];
      }
      setUserInfo({ token, fullName, userType: userType, mobile, profilePicture, userName, accessLevel: accessLevel, id: id });

      setIsLogged(true);
      Cookies.set("token", token);
      Cookies.set("fullName", fullName);
      Cookies.set("userType", userType);
      Cookies.set("mobile", mobile);
      Cookies.set("profilePicture", profilePicture);
      Cookies.set("userName", userName);
      Cookies.set("accessLevel", accessLevel);
      Cookies.set("id", +id);
      Cookies.set("isLogged", true);
    }
  }

  function logout(): void {
    setUserInfo({ token: "", fullName: "", userType: -1, mobile: 0, profilePicture: "", userName: "", accessLevel: [], id: null });
    setIsLogged(false);
    Cookies.remove("token");
    Cookies.remove("fullname");
    Cookies.remove("mobile");
    Cookies.remove("userType");
    Cookies.remove("profilePicture");
    Cookies.remove("userName");
    Cookies.remove("accessLevel");
    Cookies.remove("id");
    Cookies.set("isLogged");
  }

  function checkCookie(): void {
    login(Cookies.get("token"), Cookies.get("fullname"), Cookies.get("userType"), Cookies.get("mobile"), Cookies.get("profilePicture"), Cookies.get("userName"), Cookies.get("accessLevel"), Cookies.get("id"));
  }

  return (
    <>
      <AuthenticationContext.Provider
        value={{
          login,
          userInfo,
          isLogged,
          logout,
        }}
      >
        {children}
      </AuthenticationContext.Provider>
    </>
  );
}
